module.exports = __webpack_public_path__ + "img/my_logo.fbcfd8cb.png";